'use client';

import { useFormatter } from 'next-intl';

type DisplayCurrencyProps = {
  value: number;
  currencyCode: string;
  className?: string;
};

export const DisplayPrice = ({ value, currencyCode, className }: DisplayCurrencyProps) => {
  const format = useFormatter();

  return (
    <span className={className}>
      {format.number(value, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })}
    </span>
  );
};
